import { render, staticRenderFns } from "./campaignElementTile.vue?vue&type=template&id=2c34fac8"
import script from "./campaignElementTile.vue?vue&type=script&lang=js"
export * from "./campaignElementTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports